<template>
    <div>
        <el-row class="video-tree flex" >
            <el-col :span="treespan"  v-show="showTree"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <product-tree @showData="showData"></product-tree>
            </el-col>
            <el-col :span="tablespan"  style="height: 100%;min-width: 320px;width: 100%">
                <div style="display: flex;justify-content: space-between;margin: 10px ;">
<!--                    <div>-->
                        <el-input
                                style="width: 220px"
                                size="mini"
                                class="input"
                                placeholder="产品名称"
                                v-model="searchInfo.mc"
                                clearable>
                        </el-input>
                        <el-input
                                style="width: 220px"
                                size="mini"
                                class="input"
                                placeholder="产地"
                                v-model="searchInfo.cd"
                                clearable>
                        </el-input>
                        <el-input
                                style="width: 220px"
                                size="mini"
                                class="input"
                                placeholder="厂家"
                                v-model="searchInfo.cj"
                                clearable>
                        </el-input>
                        <el-input
                                style="width: 220px"
                                size="mini"
                                class="input"
                                placeholder="规格型号"
                                v-model="searchInfo.xh"
                                clearable>
                        </el-input>
                        <el-button class="mrl20" style="margin-left: 10px" icon="el-icon-search" circle  @click="searchData" size="mini"></el-button>
                        <el-button class="mrl20" icon="el-icon-refresh" circle  @click="clearSearchData" size="mini"></el-button>
<!--                    </div>-->
<!--                    <el-button class="marB10" style="height: fit-content" @click="editPro" :class="baseerp+'btn'" size="mini">-->
<!--                        编辑产品-->
<!--                    </el-button>-->
                    <el-button type="primary" @click="saveadd" :disabled="disabled" size="mini">{{$t('button_save')}}</el-button>

                    <!--                    <el-button class="marB10" style="height: fit-content" @click="transferOut" :class="baseerp+'btn'" size="mini">-->
<!--                        产品转出-->
<!--                    </el-button>-->
                </div>

                <el-table
                        ref="table"
                        size="mini"
                        :height="tableHeight"
                        border
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        style="width: initial;">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column align="center" label="产品大类ID" prop="i_pid"></el-table-column>
                    <el-table-column align="center" label="产品大类" prop="vc_pname" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="产品名" prop="vc_name" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="英文名" prop="vc_ename" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="别名" prop="vc_name_nick" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="包装规格" prop="vc_bzstyle" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="单件净重" prop="f_weight" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="比例(吨)" prop="f_bl" sow-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="单位" prop="vc_unit" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="产地" prop="vc_cd" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="厂家" prop="vc_gykh" show-overflow-tooltip></el-table-column>
<!--                    <el-table-column align="center" label="品牌" prop="i_state" show-overflow-tooltip></el-table-column>-->
                    <el-table-column align="center" label="是否化验" prop="i_assayres" >
                        <template slot-scope="scope" >
                            <el-select style="width:100%" size="mini" v-model="scope.row.i_assayres"  v-if="multipleSelectionId.includes(scope.row.i_id)"   >
                                <el-option
                                        v-for="item in YorN"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.i_assayres?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="卸货是否必检" prop="i_ismustcheck" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-select style="width:100%" size="mini" v-model="scope.row.i_ismustcheck"  v-if="multipleSelectionId.includes(scope.row.i_id)"   >
                                <el-option
                                        v-for="item in YorN"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.i_ismustcheck?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否按件计量" prop="isjian" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.isjian?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="是否启用" prop="isuse" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.isuse?'是':'否'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="录入时间" prop="dt_createtime" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="录入人" prop="vc_lruname" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" label="是否批次核算"  prop="i_ispno" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-select style="width:100%" size="mini" v-model="scope.row.i_ispno"  v-if="multipleSelectionId.includes(scope.row.i_id)"   >
                                <el-option
                                        v-for="item in GuiPi"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.i_ispno==3?'批次':'规格'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="成本核算"  prop="i_type" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-select style="width:100%" size="mini" v-model="scope.row.i_type"  v-if="multipleSelectionId.includes(scope.row.i_id)"   >
                                <el-option
                                        v-for="item in GuiDa"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-else>{{scope.row.i_type==2?'按大类':'按规格'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="生产库存核算"  prop="i_pzid_kcjs" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-select style="width:100%" size="mini" v-model="scope.row.i_pzid_kcjs"  v-if="multipleSelectionId.includes(scope.row.i_id)"   >
                                <el-option
                                        v-for="item in GuiDa"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                            <span>{{scope.row.i_pzid_kcjs==2?'按大类':'按规格'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="产品属性"  prop="flagTxt" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-select style="width: 200px" size="mini" v-model="scope.row.i_flag" placeholder="产品属性"  v-if="multipleSelectionId.includes(scope.row.i_id)" >
                                <el-option
                                        v-for="item in pzsxListData"
                                        :key="item.i_id"
                                        :label="item.vc_name"
                                        :value="item.i_id">
                                </el-option>
                            </el-select>
                            <span>{{scope.row.flagTxt}}</span>

                        </template>
                    </el-table-column>
<!--                    <el-table-column label="操作" width="80" align="center">-->
<!--                        <template slot-scope="scope">-->
<!--                            <el-button style="padding: 5px 10px"-->
<!--                                       size="mini"-->
<!--                                       type="text"-->
<!--                                       @click="details(scope.row)">查看-->
<!--                            </el-button>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                </el-table>
                <el-pagination  style="margin-top: 10px;text-align: right"
                                background
                                @current-change="pageCurrentChange"
                                layout="total,prev, pager, next"
                                :current-page.sync="currentPage"
                                :total="total"
                                :page-size="pageSize">
                </el-pagination>
            </el-col>

        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="editTitle"
                       width="60%"
                       top="30px"
                       :visible.sync="editDialog"
                       :close-on-click-modal="false"
                       @close="closeEditDialog">

                <multiple-edit-dialog v-if="editDialog" @close="closeEditFun" :idList="multipleSelectionId"></multiple-edit-dialog>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    import * as API from "./api"
    import ProductTree from "./compontents/ProductTree";
    import MultipleEditDialog from "./compontents/MultipleEditDialog";

    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: 'productManage',
        components: {ProductTree,MultipleEditDialog},
        data() {
            return {
                showTree:true,//树显示按钮
                treespan:4,
                tablespan:24 - this.treespan,
                tableHeight:0,//列表高度
                baseerp:'',
                tableData:[],
                multipleSelection:[],
                multipleSelectionId:[],
                YorN:[{value:0,label:'否'},{value:1,label:'是'}],
                GuiDa:[{value:2,label:'按大类'},{value:1,label:'按规格'}],
                GuiPi:[{value:3,label:'批次'},{value:0,label:'规格'}],

                searchInfo:{mc:'',cd:'',cj:'',xh:'',cz:""},
                editDialog:false,
                editTitle:'编辑',
                currentPage:1,
                pageSize:20,
                total:0,
                listparamid:0,
                pzsxListData:[],
                disabled:false
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.baseerp=baseerp
            this.listpzsx()

            this.$nextTick(()=>{
                this.onResize();

            })

        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            showData(val){
                // console.log(val,'--------')
                this.listparamid=val.i_obj
                this.currentPage=1
                this.list()
            },
            handleSelectionChange(val){
                this.multipleSelection=val
                this.multipleSelectionId=this.multipleSelection.map((m)=> m.i_id)
            },
            clearSearchData(){
                this.searchInfo={mc:'',cd:'',cj:'',xh:'',cz:""}
                this.currentPage=1

                this.list()

            },
            searchData(){
                this.currentPage=1
                this.list()
            },
            editPro(){
                if (this.multipleSelection.length>0){
                    this.editDialog=true

                }else{
                    this.$message.warning('请选择要编辑的产品')
                }

            },
            transferOut(){},
            closeEditDialog(){
                this.editDialog=false
            },
            closeEditFun(type='close'){
                this.editDialog=false
                if(type=='save'){
                    this.list()
                    this.multipleSelection=[]
                    this.multipleSelectionId=[]
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                    this.currentPage=val;
                    //调用列表接口
                    this.list();

            },
            async list(){
                // if(this.listparamid){
                    let param={
                        currentPage:this.currentPage,
                        pageSize: this.pageSize,
                        i_id:this.listparamid,
                        vc_name:this.searchInfo.mc,
                        vc_cd:this.searchInfo.cd,
                        vc_gykh:this.searchInfo.cj,
                        vc_bzstyle:this.searchInfo.xh,
                    };
                    let res=await API.list(param);
                    if(res.code==1){
                        this.tableData=res.data.list;
                        this.total=res.data.total;
                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else{
                        this.$message.error(res.message);
                    }
                // }else{
                //     this.$message.warning('请选择产品')
                // }

            },
            async listpzsx(){
                let param={
                    // i_mid: this.mid,
                };
                let res=await API.listpzsx(param);
                if(res.code==1){
                    if (res.data.length>0){
                        this.pzsxListData=res.data;
                    }
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            saveadd(){
                if(this.multipleSelection.length>0){
                    this.$confirm('确认保存?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(  () => {
                        this.edit()
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                }else{
                    this.$message.warning('请选择要编辑的产品')
                }

            },
            async edit(){
                    let param={
                        list:this.multipleSelection
                    }
                    // console.log(param,'param')
                    // return
                    let res=await API.edit(param);
                    if(res.code==1){
                        this.list()
                    }else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    }
                    else{
                        this.$message.error(res.message);
                    }

            },

        }
    }
</script>
